<template>
    <div class="shop-cars">
        <div class="title">
            {{ shopObj.nickName }} 还有
            <div class="more">
                <a href="#" @click.prevent="selectShop()">查看更多</a>
            </div>
        </div>
        <div class="shop-cars-list">
            <template v-for="row in carsRows">
                <div class="car-item-container" v-for="item in row.childArr">
                    <a :href="'/car/' + item.id">
                        <div is="CarItem"
                            :data="item"
                            :class="['line-height-level-' + row.lineHeightLevel]">
                        </div>
                    </a>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import CarItem from '@souche-f2e/wangzhan-dependencies-car-item';
    import {
        getLineHeightLevel
    } from 'babel!@souche-f2e/wangzhan-dependencies-car-item/src/car-util.js';
    export default {
        props: [ 'shop', 'cars' ],
        computed: {
            shopObj() {
                return this.shop && JSON.parse(this.shop);
            },
            /**
             * 将车辆列表处理为一个二维数组
             * 每行有四辆车
             * 其中最大高度的车为当前行所有车的高度
             * @Author   Bolt
             * @DateTime 2017-03-09T18:07:42+0800
             * @return   {[type]}                 [description]
             */
            carsRows() {
                let arr = [];
                for (var i = 0; i < this.cars.length / 4; i++) {
                    let rowObj = {
                        lineHeightLevel: 0,
                        childArr: []
                    };
                    for (var j = 0; j < 4; j++) {
                        let carIndex = i * 4 + j;
                        let carItem = this.cars[carIndex];
                        if (carItem) {
                            let lineHeightLevel = getLineHeightLevel(carItem);
                            if (lineHeightLevel > rowObj.lineHeightLevel) {
                                rowObj.lineHeightLevel = lineHeightLevel;
                            }
                            rowObj.childArr.push(carItem);
                        }
                    }
                    arr.push(rowObj);
                }
                return arr;
            }
        },
        components: {
            CarItem
        }
    };
</script>

<style lang="less" scoped>
.shop-cars {
    .title {
        border-bottom: #e4e4e4 solid 1px;
        margin: 10px 0 10px 20px;
        font-size: 16px;
        line-height: 30px;
        height: 30px;
        color: #FF5517;
        .more {
            float: right;
            margin-right: 20px;
        }
    }
    .shop-cars-list {
        .car-item-container {
            margin: 0 0 20px 20px;
            float: left;
            .car-item {
                // 无弹个车标且无售价 -22px -29px;
                &.line-height-level-0 {
                    height: 343px - 22px - 29px;
                }
                // 无售价 -22px
                &.line-height-level-1 {
                    height: 343px - 22px;
                }
                &.line-height-level-2 {
                    height: 343px;
                }
            }
        }
        &:after {
            content: '';
            display: block;
            clear: both;
        }
    }
}
</style>



// WEBPACK FOOTER //
// ShopCars.vue?bc0053dc